import React, { useState } from 'react'

function SocialNetwork(props: React.SVGProps<SVGSVGElement>) {
  const [activeLink, setActiveLink] = useState<string | null>(null)

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      data-name="Camada 1"
      viewBox="0 0 797.1 1175"
      {...props}
    >
      <defs>
        <linearGradient
          id="Gradiente_sem_nome"
          x1="91.02"
          x2="83.01"
          y1="756.43"
          y2="748.2"
          gradientTransform="matrix(1 0 0 -1 -3.11 1373.55)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#e02041"></stop>
          <stop offset="1" stopColor="#4347fe"></stop>
        </linearGradient>
        <linearGradient
          id="Gradiente_sem_nome_116"
          x1="423.51"
          x2="426.94"
          y1="780.97"
          y2="105.21"
          gradientTransform="translate(0 384)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#121214" stopOpacity="0"></stop>
          <stop offset="1" stopColor="#0b080b" stopOpacity="0.8"></stop>
        </linearGradient>
        <linearGradient
          id="Gradiente_sem_nome_4"
          x1="431.31"
          x2="431.31"
          y1="773.56"
          y2="122.81"
          gradientTransform="translate(-3.11 383.55)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#121214" stopOpacity="0"></stop>
          <stop offset="1" stopColor="#121214"></stop>
        </linearGradient>
        <linearGradient
          id="Gradiente_sem_nome_6"
          x1="421.45"
          x2="423.85"
          y1="539.89"
          y2="473.65"
          gradientTransform="translate(-3.11 383.55)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.02" stopColor="#fff" stopOpacity="0"></stop>
          <stop offset="0.65" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="Gradiente_sem_nome_7"
          x1="226.31"
          x2="226.31"
          y1="948.55"
          y2="900.31"
          gradientTransform="matrix(1 0 0 -1 -3.11 1373.55)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff"></stop>
          <stop offset="1" stopColor="#f9f9f9" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="Gradiente_sem_nome_8"
          x1="393.06"
          x2="393.06"
          y1="1288.55"
          y2="934.83"
          xlinkHref="#Gradiente_sem_nome_7"
        ></linearGradient>
        <linearGradient
          id="Gradiente_sem_nome_9"
          x1="579.59"
          x2="579.59"
          y1="1194.55"
          y2="911.57"
          xlinkHref="#Gradiente_sem_nome_7"
        ></linearGradient>
        <linearGradient
          id="Gradiente_sem_nome_10"
          x1="627.81"
          x2="627.81"
          y1="958.55"
          y2="885.51"
          xlinkHref="#Gradiente_sem_nome_7"
        ></linearGradient>
        <linearGradient
          id="Gradiente_sem_nome_11"
          x1="676.7"
          x2="608.65"
          y1="711.44"
          y2="626.29"
          gradientTransform="matrix(1 0 0 -1 -3.11 1373.55)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#f9f9f9"></stop>
          <stop offset="1" stopColor="#f9f9f9" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="Gradiente_sem_nome_12"
          x1="180.43"
          x2="248.48"
          y1="750.42"
          y2="665.27"
          xlinkHref="#Gradiente_sem_nome_11"
        ></linearGradient>
        <linearGradient
          id="Gradiente_sem_nome_13"
          x1="233.31"
          x2="233.31"
          y1="1215.55"
          y2="932.57"
          xlinkHref="#Gradiente_sem_nome_7"
        ></linearGradient>
        <linearGradient
          id="Gradiente_sem_nome_14"
          x1="431.31"
          x2="413.41"
          y1="1356.44"
          y2="1334.78"
          gradientTransform="matrix(1 0 0 -1 -25.51 1373.55)"
          xlinkHref="#Gradiente_sem_nome"
        ></linearGradient>
        <linearGradient
          id="Gradiente_sem_nome_15"
          x1="439.62"
          x2="435.35"
          y1="1363.11"
          y2="1357.94"
          gradientTransform="matrix(1 0 0 -1 -25.51 1373.55)"
          xlinkHref="#Gradiente_sem_nome"
        ></linearGradient>
        <linearGradient
          id="Gradiente_sem_nome_16"
          x1="120.07"
          x2="95.41"
          y1="1279.75"
          y2="1266.33"
          xlinkHref="#Gradiente_sem_nome"
        ></linearGradient>
        <linearGradient
          id="Gradiente_sem_nome_17"
          x1="106.06"
          x2="101.19"
          y1="1291.11"
          y2="1273.75"
          xlinkHref="#Gradiente_sem_nome"
        ></linearGradient>
        <linearGradient
          id="Gradiente_sem_nome_18"
          x1="113.71"
          x2="106.47"
          y1="1273.48"
          y2="1253"
          xlinkHref="#Gradiente_sem_nome"
        ></linearGradient>
        <linearGradient
          id="Gradiente_sem_nome_19"
          x1="745.72"
          x2="744.5"
          y1="1223"
          y2="1217.84"
          gradientTransform="matrix(1 0 0 -1 -25.51 1373.55)"
          xlinkHref="#Gradiente_sem_nome"
        ></linearGradient>
        <linearGradient
          id="Gradiente_sem_nome_20"
          x1="758.01"
          x2="730.63"
          y1="987.16"
          y2="957.8"
          xlinkHref="#Gradiente_sem_nome"
        ></linearGradient>
        <linearGradient
          id="Gradiente_sem_nome_21"
          x1="788.9"
          x2="753.9"
          y1="730.84"
          y2="688.49"
          xlinkHref="#Gradiente_sem_nome"
        ></linearGradient>
        <linearGradient
          id="Gradiente_sem_nome_22"
          x1="772.59"
          x2="771.06"
          y1="690.73"
          y2="690.63"
          xlinkHref="#Gradiente_sem_nome"
        ></linearGradient>
        <linearGradient
          id="Gradiente_sem_nome_23"
          x1="772.04"
          x2="765.38"
          y1="721.88"
          y2="698.86"
          xlinkHref="#Gradiente_sem_nome"
        ></linearGradient>
        <linearGradient
          id="Gradiente_sem_nome_24"
          x1="777.27"
          x2="770.61"
          y1="720.36"
          y2="697.34"
          xlinkHref="#Gradiente_sem_nome"
        ></linearGradient>
        <linearGradient
          id="Gradiente_sem_nome_25"
          x1="772.59"
          x2="771.06"
          y1="728.53"
          y2="728.43"
          xlinkHref="#Gradiente_sem_nome"
        ></linearGradient>
        <linearGradient
          id="Gradiente_sem_nome_26"
          x1="102.08"
          x2="76.66"
          y1="951.44"
          y2="934.83"
          xlinkHref="#Gradiente_sem_nome"
        ></linearGradient>
      </defs>
      <g
        className={`social-network-item ${
          activeLink === 'youtube' ? 'is-active' : ''
        }`}
      >
        <path
          fill="#171719"
          d="M58.5 609.6c-2.3 10.6-1 22.7 0 27.4a7.79 7.79 0 006.3 5c23.8 1.5 37 .6 40.6 0a7.63 7.63 0 007.1-5.3c2-10.2.8-22.3 0-27a7.57 7.57 0 00-7.1-5.8c-14.2-1.4-33-.6-40.6 0a6.91 6.91 0 00-6.3 5.7z"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="url(#Gradiente_sem_nome)"
          stroke="url(#Gradiente_sem_nome)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.972"
          d="M80.1 616.5l10.7 6.3-10.7 6.3z"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="#4347fe"
          d="M40.2 670c.5-.9 1.1-1.8 1.6-2.7s1-1.9 1.4-2.8h2.5c-.7 1.3-1.4 2.5-2.1 3.8s-1.5 2.5-2.3 3.8v4.9H39v-4.9c-.8-1.3-1.6-2.5-2.3-3.8s-1.4-2.5-2.1-3.8h2.7c.4.9.9 1.9 1.4 2.8a18.21 18.21 0 001.5 2.7zm11.9.8a6.28 6.28 0 00.3 1.9 6.11 6.11 0 00.7 1.4 3.68 3.68 0 004.3.9 4.7 4.7 0 001.2-.9 3.69 3.69 0 00.7-1.4 5.82 5.82 0 00.3-1.9 6.28 6.28 0 00-.3-1.9 3.69 3.69 0 00-.7-1.4 2.73 2.73 0 00-1.2-.9 4.15 4.15 0 00-3.1 0 2.73 2.73 0 00-1.2.9 3.69 3.69 0 00-.7 1.4 4 4 0 00-.3 1.9zm9.7 0a6.63 6.63 0 01-.5 2.8 4.64 4.64 0 01-1.3 2 4.74 4.74 0 01-1.9 1.2 6.81 6.81 0 01-4.6 0 6.15 6.15 0 01-1.9-1.2 5.71 5.71 0 01-1.3-2.1 9.18 9.18 0 01-.5-2.8 6.63 6.63 0 01.5-2.8 6.25 6.25 0 011.3-2 8 8 0 011.9-1.3 7.55 7.55 0 014.7 0 5 5 0 011.9 1.3 5.33 5.33 0 011.3 2 9.25 9.25 0 01.4 2.9zm10.9 6.5a5.7 5.7 0 01-2.2-.4 4 4 0 01-1.5-1 5.07 5.07 0 01-.9-1.6 6.45 6.45 0 01-.3-2v-7.8h2.3v7.6a7.72 7.72 0 00.2 1.5 3.13 3.13 0 00.5 1 2.18 2.18 0 00.8.5 3.59 3.59 0 001.1.2 4.25 4.25 0 001.1-.2 2.18 2.18 0 00.8-.5 1.91 1.91 0 00.5-1 7.72 7.72 0 00.2-1.5v-7.6h2.3v7.8a6.45 6.45 0 01-.3 2 5.07 5.07 0 01-.9 1.6 4 4 0 01-1.5 1 5.38 5.38 0 01-2.2.4zm20.2-12.8v2H89V677h-2.3v-10.6h-3.8v-2zm10.1 12.8a5.7 5.7 0 01-2.2-.4 4 4 0 01-1.5-1 5.07 5.07 0 01-.9-1.6 6.45 6.45 0 01-.3-2v-7.8h2.3v7.6a7.72 7.72 0 00.2 1.5 3.13 3.13 0 00.5 1 2.18 2.18 0 00.8.5 3.59 3.59 0 001.1.2 4.25 4.25 0 001.1-.2 1.56 1.56 0 00.8-.6 1.91 1.91 0 00.5-1 7.72 7.72 0 00.2-1.5v-7.5h2.3v7.8a6.45 6.45 0 01-.3 2 5.07 5.07 0 01-.9 1.6 4 4 0 01-1.5 1 5.7 5.7 0 01-2.2.4zm15.2-.1a13.4 13.4 0 01-2-.1 5.66 5.66 0 01-1.8-.3v-12.1c.3 0 .6-.1.8-.1s.6-.1.9-.1h1.8a14.92 14.92 0 012.1.2 5.78 5.78 0 011.7.6 2.66 2.66 0 011.1 1 2.93 2.93 0 01.4 1.6 2.6 2.6 0 01-.4 1.5 2.94 2.94 0 01-1.2 1 3.37 3.37 0 011.7 1.1 2.51 2.51 0 01.5 1.9 3.42 3.42 0 01-1.4 2.9 8.36 8.36 0 01-4.2.9zm-1.5-5.8v3.8a2.2 2.2 0 01.8.1h.8a5.7 5.7 0 001.3-.1l1-.3c.3-.1.5-.4.7-.6a1.69 1.69 0 00.3-1 1.41 1.41 0 00-.8-1.5 5.22 5.22 0 00-2.1-.4zm0-1.8h1.6a4.48 4.48 0 002-.4 1.28 1.28 0 00.7-1.3 1.44 1.44 0 00-.8-1.3 4.48 4.48 0 00-2-.4h-.9a1.48 1.48 0 00-.7.1zm13.2 7.4v-12.5h8v1.9h-5.7v3.1h5.1v1.9h-5.1v3.7h6.2v1.9z"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="#fff"
          d="M34 699.2h-1.2l4.7-12.4h1.2zm9.9-6.1a6.63 6.63 0 01-2.8-1.4 2.52 2.52 0 01-.9-2 2.79 2.79 0 011.1-2.2 4.28 4.28 0 012.8-.9 4.65 4.65 0 012.1.5 3 3 0 011.4 1.3 3.37 3.37 0 01.5 1.7h-1.5a1.86 1.86 0 00-.7-1.6 2.71 2.71 0 00-1.9-.6 2.86 2.86 0 00-1.7.5 1.68 1.68 0 00-.6 1.4 1.43 1.43 0 00.6 1.2 7.66 7.66 0 002 .9 12.29 12.29 0 012.2.9 4.26 4.26 0 011.2 1.1 2.41 2.41 0 01.4 1.5 2.66 2.66 0 01-1.1 2.2 4.35 4.35 0 01-2.9.8 5.38 5.38 0 01-2.2-.4 4 4 0 01-1.6-1.2 2.73 2.73 0 01-.5-1.8h1.5a1.94 1.94 0 00.8 1.6 3.17 3.17 0 002 .6 3 3 0 001.8-.5 1.61 1.61 0 00.6-1.3 1.49 1.49 0 00-.6-1.3 4.06 4.06 0 00-2-1zm14.9-.2a6.53 6.53 0 01-.6 2.9 4.31 4.31 0 01-1.6 1.9 4.81 4.81 0 01-2.4.7 4 4 0 01-2.4-.7 4.31 4.31 0 01-1.6-1.9 6.39 6.39 0 01-.6-2.8v-.8a6.53 6.53 0 01.6-2.9 4.31 4.31 0 011.6-1.9 4.81 4.81 0 012.4-.7 4 4 0 012.4.7 4.31 4.31 0 011.6 1.9 6.53 6.53 0 01.6 2.9zm-1.5-.8a5.45 5.45 0 00-.8-3.1 2.71 2.71 0 00-2.3-1.1A2.66 2.66 0 0052 689a5.1 5.1 0 00-.8 3v.8a5.69 5.69 0 00.8 3.1 3 3 0 004.6 0 5.1 5.1 0 00.8-3v-.8zm5.3 4.9H68v1.2h-6.9v-11.4h1.5zm11.2-3.4h-2.7v4.6h-1.5v-11.4h3.8a4.48 4.48 0 013 .9 3 3 0 011 2.5 3.29 3.29 0 01-.6 1.9 4 4 0 01-1.6 1.2l2.7 4.8v.1h-1.6zm-2.6-1.2h2.3a2.79 2.79 0 001.8-.6 2.17 2.17 0 00.1-3.1 2.44 2.44 0 00-1.8-.6h-2.3v4.3zm14.6 2.8H81l-1.1 3h-1.5l4.3-11.4H84l4.4 11.4h-1.5zm-4.3-1.2h3.9l-1.9-5.3zm16.7.6a4.34 4.34 0 01-1.3 2.8 4 4 0 01-3 1 4.16 4.16 0 01-3.2-1.4 6.05 6.05 0 01-1.2-3.9V692a6.09 6.09 0 01.6-2.8 4 4 0 011.6-1.8 4.75 4.75 0 012.4-.6 4 4 0 012.9 1 4.34 4.34 0 011.3 2.8h-1.5a2.89 2.89 0 00-.9-2 2.44 2.44 0 00-1.8-.6 2.84 2.84 0 00-2.3 1.1 5.1 5.1 0 00-.8 3v1.1a5 5 0 00.8 2.9 2.53 2.53 0 002.2 1.1 2.71 2.71 0 001.9-.6 3.73 3.73 0 00.9-2zm10.8 3.6h-1.5v-5.3h-5.7v5.3h-1.5v-11.4h1.5v4.9h5.7v-4.9h1.5zm4.3 0h-1.5v-11.4h1.5zm6.6-7l2.7-4.4h1.8l-3.6 5.6 3.7 5.7h-1.8l-2.8-4.4-2.8 4.4h-1.8l3.7-5.7-3.6-5.6h1.8z"
          transform="translate(-22.4)"
        ></path>
      </g>
      <g>
        <path
          fill="#171719"
          d="M587.2 628.8a.79.79 0 01.8-.8 2.48 2.48 0 012.5 2.5v68.1a2.48 2.48 0 01-2.5 2.5.86.86 0 01-.8-.8zM259.2 578a3 3 0 013-3h.1a.94.94 0 011 1v23.5a.94.94 0 01-1 1h-.1a3 3 0 01-3-3zM259.2 621.5a2.48 2.48 0 012.5-2.5h.8a.79.79 0 01.8.8v42.7a.79.79 0 01-.8.8h-.8a2.48 2.48 0 01-2.5-2.5zM259.2 681.5a2.48 2.48 0 012.5-2.5h.8a.79.79 0 01.8.8v42.7a.79.79 0 01-.8.8h-.8a2.48 2.48 0 01-2.5-2.5z"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="url(#Gradiente_sem_nome_116)"
          d="M309.2 489h232a48 48 0 0148 48v590a48 48 0 01-48 48h-232a48 48 0 01-48-48V537a48 48 0 0148-48z"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="#505050"
          d="M408.2 507h32a2 2 0 012 2 2 2 0 01-2 2h-32a2 2 0 01-2-2 2 2 0 012-2z"
          transform="translate(-22.4)"
        ></path>
        <circle cx="436.8" cy="509" r="4" fill="#505050"></circle>
        <path
          fill="url(#Gradiente_sem_nome_4)"
          fillRule="evenodd"
          d="M342.2 507v-1a7 7 0 00-7-7h-23a38 38 0 00-38 38v591a38 38 0 0038 38h232a38 38 0 0038-38V537a38 38 0 00-38-38h-22a7 7 0 00-7 7v1a17 17 0 01-17 17h-139a17 17 0 01-17-17z"
          data-name="Subtract 2"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="#4347fe"
          stroke="#344d97"
          strokeMiterlimit="10"
          d="M315.2 871.2l26.7 9.4v13.1l-40.4-17.1v-11.1l40.4-17.1v13.1zM475.8 946h-10.1l25.1-74.1h10.1zm59.3-35l-27.2-9.5v-13l40.8 17.1v11l-40.8 17.1v-13.1z"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="url(#Gradiente_sem_nome_6)"
          d="M406.5 897.4c-.5 7.3-3.2 13.1-8.2 17.3S387 921 379 921c-8.7 0-15.6-2.9-20.7-8.8s-7.5-14-7.5-24.3v-4.2a40.9 40.9 0 013.5-17.3 26.29 26.29 0 019.9-11.5 28.14 28.14 0 0115-4c7.9 0 14.2 2.1 19 6.3s7.6 10.1 8.3 17.8h-14c-.3-4.4-1.6-7.6-3.7-9.6s-5.3-3-9.6-3q-7.05 0-10.5 5.1t-3.6 15.6v5.2q0 11.1 3.3 16.2c2.2 3.4 5.8 5.1 10.6 5.1 4.3 0 7.6-1 9.7-3s3.4-5.1 3.7-9.2zm27.6-45.5l17.5 49.5 17.4-49.5h18.5v68.3h-14.1v-18.6l1.4-32.2-18.4 50.8h-9.7l-18.4-50.8 1.4 32.2v18.7h-14.1V852h18.5z"
          transform="translate(-22.4)"
        ></path>
      </g>
      <path
        fill="none"
        stroke="url(#Gradiente_sem_nome_7)"
        strokeWidth="3"
        d="M145.2 425l31.5 31.5h103.5l21 21"
        transform="translate(-22.4)"
      ></path>
      <path
        fill="none"
        stroke="url(#Gradiente_sem_nome_8)"
        strokeWidth="3"
        d="M421.2 85v101l-62.5 62.6V327l62.5 62.5V470"
        transform="translate(-22.4)"
      ></path>
      <path
        fill="none"
        stroke="url(#Gradiente_sem_nome_9)"
        strokeWidth="3"
        d="M652.2 179l-70.5 70.6V308l-80.5 80.5V487"
        transform="translate(-22.4)"
      ></path>
      <path
        fill="none"
        stroke="url(#Gradiente_sem_nome_10)"
        strokeWidth="3"
        d="M691.2 415l-67.5 67.5h-53.5l-12 12"
        transform="translate(-22.4)"
      ></path>
      <path
        fill="none"
        stroke="url(#Gradiente_sem_nome_11)"
        strokeWidth="3"
        d="M704.7 664h-56l-42 42v45l-17.5 17.5"
        transform="translate(-22.4)"
      ></path>
      <path
        fill="none"
        stroke="url(#Gradiente_sem_nome_12)"
        strokeWidth="3"
        d="M146.2 625h56l42 42v45l17.5 17.5"
        transform="translate(-22.4)"
      ></path>
      <circle
        cx="123.3"
        cy="426.5"
        r="6"
        fill="#121214"
        stroke="#4347fe"
        strokeWidth="3"
      ></circle>
      <path
        fill="none"
        stroke="url(#Gradiente_sem_nome_13)"
        strokeWidth="3"
        d="M125.2 158l76 76v98l134 134"
        transform="translate(-22.4)"
      ></path>
      <circle
        cx="398.3"
        cy="82.5"
        r="6"
        fill="#121214"
        stroke="#4347fe"
        strokeWidth="3"
        data-name="figny8-isle 2"
      ></circle>
      <circle
        cx="627.3"
        cy="180.5"
        r="6"
        fill="#121214"
        stroke="#4347fe"
        strokeWidth="3"
        data-name="figny8-isle 3"
      ></circle>
      <circle
        cx="669.3"
        cy="414.5"
        r="6"
        fill="#121214"
        stroke="#4347fe"
        strokeWidth="3"
        data-name="figny8-isle 4"
      ></circle>
      <circle
        cx="682.8"
        cy="663.5"
        r="6"
        fill="#121214"
        stroke="#4347fe"
        strokeWidth="3"
        data-name="figny8-isle 5"
      ></circle>
      <g
        className={`social-network-item ${
          activeLink === 'instagram' ? 'is-active' : ''
        }`}
      >
        <path
          fill="#171719"
          d="M406.9 0h24.7a15.62 15.62 0 0115.6 15.6v24.7a15.62 15.62 0 01-15.6 15.6h-24.7a15.62 15.62 0 01-15.6-15.6V15.6A15.49 15.49 0 01406.9 0z"
          transform="translate(-22.4)"
        ></path>
        <circle
          cx="396.8"
          cy="28"
          r="11.6"
          fill="none"
          stroke="url(#Gradiente_sem_nome_14)"
          strokeWidth="5.359"
        ></circle>
        <circle
          cx="412"
          cy="13"
          r="3.4"
          fill="url(#Gradiente_sem_nome_15)"
        ></circle>
        <path
          fill="#4347fe"
          d="M464.7 11.6h2.3V24h-2.3zM482 24c-.4-.7-.9-1.4-1.4-2.2s-1-1.6-1.6-2.4-1.1-1.6-1.7-2.3-1.1-1.4-1.6-2V24h-2.2V11.6h1.9a14.28 14.28 0 011.5 1.8c.5.7 1.1 1.4 1.6 2.1s1.1 1.5 1.6 2.2 1 1.4 1.4 2.1v-8.3h2.2V24zm11.5-1.7a3.92 3.92 0 001.8-.4 1.43 1.43 0 00.6-1.2 2.35 2.35 0 00-.2-.8 2.65 2.65 0 00-.5-.6 3.51 3.51 0 00-.8-.5 11.73 11.73 0 01-1.1-.5c-.4-.2-.9-.3-1.3-.5a6.73 6.73 0 01-1.1-.7 3.1 3.1 0 01-1-2.4 3.57 3.57 0 011.2-2.7 4.55 4.55 0 013.2-1 7.61 7.61 0 012.1.3 3.51 3.51 0 011.4.6l-.7 1.8a5.78 5.78 0 00-1.4-.5 7.72 7.72 0 00-1.5-.2 2.3 2.3 0 00-1.4.4 1.29 1.29 0 00-.5 1.1 1.85 1.85 0 00.2.7 1.21 1.21 0 00.5.5 2.51 2.51 0 00.7.4c.3.1.6.3.9.4a11.11 11.11 0 011.6.7 8.34 8.34 0 011.2.8 2.59 2.59 0 01.7 1.1 4 4 0 01.3 1.5 3 3 0 01-1.2 2.6 5.43 5.43 0 01-3.5.9 6.15 6.15 0 01-1.4-.1 3.59 3.59 0 01-1.1-.2l-.9-.3-.6-.3.7-1.9a6.94 6.94 0 001.3.5 2.73 2.73 0 001.8.5zm19-10.7v2h-3.8V24h-2.3V13.5h-3.8v-1.9zM525.1 24c-.2-.5-.3-1-.5-1.5s-.3-1-.5-1.5h-5.3c-.2.5-.3 1-.5 1.5l-.5 1.4h-2.4c.5-1.3.9-2.6 1.3-3.7s.8-2.2 1.2-3.2.8-2 1.2-2.9l1.2-2.7h2.1l1.2 2.7c.4.9.8 1.9 1.2 2.9s.8 2.1 1.2 3.2.9 2.4 1.3 3.7zm-3.7-10c-.3.6-.6 1.4-1 2.3s-.7 1.9-1.1 3h4.1c-.4-1.1-.8-2.1-1.1-3a13.8 13.8 0 00-.9-2.3zm16.9-.7a3.85 3.85 0 00-3 1.2 5 5 0 00-1 3.3 13.66 13.66 0 00.2 1.9 3.69 3.69 0 00.7 1.4 2.73 2.73 0 001.2.9 4.67 4.67 0 001.7.3h1c.2 0 .5-.1.7-.1v-4.5h2.3v6a9.36 9.36 0 01-1.6.4 21.12 21.12 0 01-2.6.2 7.27 7.27 0 01-2.5-.4 5.86 5.86 0 01-1.9-1.3 8.17 8.17 0 01-1.2-2 8.63 8.63 0 01-.4-2.8 6.92 6.92 0 01.5-2.8 8.58 8.58 0 011.3-2 5 5 0 011.9-1.3 6.72 6.72 0 012.4-.4 7.57 7.57 0 011.5.1 5.27 5.27 0 011.2.3c.3.1.5.2.8.3l.5.2-.7 1.9a6.94 6.94 0 00-1.3-.5 3.61 3.61 0 00-1.7-.3zm13.5-1.9a7.35 7.35 0 014.1 1 3.25 3.25 0 011.4 3 3.34 3.34 0 01-2.5 3.4c.2.3.5.6.8 1a14.63 14.63 0 01.9 1.3c.3.5.6.9.9 1.4a9.14 9.14 0 01.7 1.4h-2.5c-.2-.4-.5-.9-.7-1.3a9.13 9.13 0 00-.8-1.3c-.3-.4-.5-.8-.8-1.2s-.5-.7-.7-1h-2V24h-2.3V11.7a11 11 0 011.8-.2 10.28 10.28 0 011.7-.1zm.1 2a5.28 5.28 0 00-1.3.1v4h1a7.57 7.57 0 001.5-.1 2.93 2.93 0 001-.3 1.17 1.17 0 00.6-.6 1.8 1.8 0 00.2-1 3.55 3.55 0 00-.2-1 1.17 1.17 0 00-.6-.6 1.69 1.69 0 00-1-.3 2.54 2.54 0 00-1.2-.2zm20.3 10.7c-.2-.5-.3-1-.5-1.5a8.8 8.8 0 01-.5-1.5H566c-.2.5-.3 1-.5 1.5L565 24h-2.4c.5-1.3.9-2.6 1.3-3.7s.8-2.2 1.2-3.2.8-2 1.2-2.9l1.2-2.7h2.1l1.2 2.7c.4.9.8 1.9 1.2 2.9s.8 2.1 1.3 3.2a31.92 31.92 0 011.3 3.7zM568.5 14c-.3.6-.6 1.4-1 2.3s-.7 1.9-1.1 3h4.1c-.4-1.1-.8-2.1-1.1-3s-.6-1.7-.9-2.3zm14-2.4a8.72 8.72 0 01.9 1.7c.3.7.7 1.4 1 2.1s.7 1.5 1 2.2l.9 2.1a22 22 0 00.9-2.1c.3-.8.7-1.5 1-2.2s.7-1.4 1-2.1a13.13 13.13 0 01.9-1.7h2c.1.9.2 1.9.3 2.9s.2 2.1.3 3.1.2 2.1.2 3.2.1 2.1.2 3.2h-2.2c0-1.5-.1-2.9-.2-4.5s-.2-3-.3-4.5a9.25 9.25 0 01-.5 1c-.2.4-.4.8-.6 1.3l-.6 1.4c-.2.5-.4 1-.6 1.4l-.5 1.3a6.89 6.89 0 00-.4 1h-1.7a10.37 10.37 0 01-.4-1 13.92 13.92 0 00-.6-1.3c-.2-.5-.4-.9-.6-1.4s-.4-.9-.6-1.4a6.66 6.66 0 00-.6-1.2 9.29 9.29 0 00-.5-1 30.43 30.43 0 00-.3 4.4c0 1.6-.1 3-.2 4.5h-2.2c0-1 .1-2.1.2-3.2s.2-2.2.2-3.3.2-2.1.3-3.2.2-2 .3-2.8z"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="#fff"
          d="M476 42.6a5.92 5.92 0 01-.9 3 2.84 2.84 0 01-2.3 1.1 1.77 1.77 0 01-1.9-1.3 3.18 3.18 0 01-1 1 2.28 2.28 0 01-1.1.3 2 2 0 01-1.7-.9 3.79 3.79 0 01-.4-2.5 7.75 7.75 0 01.6-2.3 4 4 0 011.2-1.6 2.45 2.45 0 011.6-.6 3.59 3.59 0 011.1.2 2.82 2.82 0 011.1.7l-.4 4.3c-.1 1.2.2 1.8 1 1.8a1.51 1.51 0 001.4-.9 3.92 3.92 0 00.6-2.3 6.85 6.85 0 00-1.1-4.6 4.47 4.47 0 00-3.9-1.6 5.38 5.38 0 00-2.8.8 5.1 5.1 0 00-1.9 2.2 9 9 0 00-.8 3.4 7.4 7.4 0 00.5 3.4 4.7 4.7 0 001.7 2.2 5.12 5.12 0 002.8.8 6.75 6.75 0 001.4-.2 8.34 8.34 0 001.2-.4l.3.9a3.92 3.92 0 01-1.3.5 8.75 8.75 0 01-1.6.2 6.4 6.4 0 01-3.4-.9 5.77 5.77 0 01-2.1-2.5 8 8 0 01-.6-3.9 10.22 10.22 0 011-3.9 6.71 6.71 0 012.4-2.6 6.4 6.4 0 013.4-.9 5.6 5.6 0 015.4 3.4 8.76 8.76 0 01.5 3.7zm-8 .7a3 3 0 00.2 1.7 1 1 0 001 .6 1.22 1.22 0 00.9-.4 3 3 0 00.7-1.1V44l.4-3.9a1.49 1.49 0 00-.9-.2 1.76 1.76 0 00-1.5.9 4.36 4.36 0 00-.8 2.5zm13.4-1.8a6.63 6.63 0 01-2.8-1.4 2.52 2.52 0 01-.9-2 2.79 2.79 0 011.1-2.2 4.28 4.28 0 012.8-.9 4.65 4.65 0 012.1.5 3 3 0 011.4 1.3 3.37 3.37 0 01.5 1.7h-1.5a1.86 1.86 0 00-.7-1.6 2.71 2.71 0 00-1.9-.6 2.86 2.86 0 00-1.7.5 1.68 1.68 0 00-.6 1.4 1.43 1.43 0 00.6 1.2 7.66 7.66 0 002 .9 12.29 12.29 0 012.2.9 4.26 4.26 0 011.2 1.1 2.41 2.41 0 01.4 1.5 2.66 2.66 0 01-1.1 2.2 4.35 4.35 0 01-2.9.8 5.38 5.38 0 01-2.2-.4 4 4 0 01-1.6-1.2 2.73 2.73 0 01-.5-1.8h1.5a1.94 1.94 0 00.8 1.6 3.17 3.17 0 002 .6 3 3 0 001.8-.5 1.71 1.71 0 000-2.6c-.2-.4-.9-.7-2-1zm14.9-.3a6.53 6.53 0 01-.6 2.9 4.31 4.31 0 01-1.6 1.9 4.81 4.81 0 01-2.4.7 4 4 0 01-2.4-.7 4.31 4.31 0 01-1.6-1.9 6.39 6.39 0 01-.6-2.8v-.8a6.53 6.53 0 01.6-2.9 4.31 4.31 0 011.6-1.9 4.81 4.81 0 012.4-.7 4 4 0 012.4.7 4.31 4.31 0 011.6 1.9 6.53 6.53 0 01.6 2.9zm-1.4-.7a5.45 5.45 0 00-.8-3.1 2.71 2.71 0 00-2.3-1.1 2.66 2.66 0 00-2.2 1.1 5.1 5.1 0 00-.8 3v.8a5.69 5.69 0 00.8 3.1 3 3 0 004.6 0 5.1 5.1 0 00.8-3v-.8zm5.2 4.8h5.4v1.2h-6.9V35.2h1.5zm11.3-3.4h-2.7v4.6h-1.5V35.2h3.8a4.48 4.48 0 013 .9 3 3 0 011 2.5 3.29 3.29 0 01-.6 1.9 4 4 0 01-1.6 1.2l2.7 4.8v.1h-1.6zm-2.7-1.2h2.3a2.79 2.79 0 001.8-.6 2.17 2.17 0 00.1-3.1 2.44 2.44 0 00-1.8-.6h-2.3v4.3zm14.6 2.9h-4.8l-1.1 3H516l4.3-11.4h1.3l4.4 11.4h-1.5zm-4.3-1.3h3.9L521 37zm16.8.6a4.34 4.34 0 01-1.3 2.8 4 4 0 01-3 1 4.16 4.16 0 01-3.2-1.4 6.05 6.05 0 01-1.2-3.9v-1.1a6.09 6.09 0 01.6-2.8 4 4 0 011.6-1.8 4.75 4.75 0 012.4-.6 4 4 0 012.9 1 4.34 4.34 0 011.3 2.8h-1.5a2.89 2.89 0 00-.9-2 2.44 2.44 0 00-1.8-.6 2.84 2.84 0 00-2.3 1.1 5.1 5.1 0 00-.8 3v1.1a5 5 0 00.8 2.9 2.53 2.53 0 002.2 1.1 2.71 2.71 0 001.9-.6 3.73 3.73 0 00.9-2zm10.8 3.6h-1.5v-5.3h-5.7v5.3h-1.5V35.2h1.5v4.9h5.7v-4.9h1.5zm4.2 0h-1.5V35.2h1.5zm6.6-7l2.7-4.4h1.8l-3.6 5.6 3.7 5.7h-1.8l-2.8-4.4-2.8 4.4h-1.8l3.7-5.7-3.6-5.6h1.8z"
          transform="translate(-22.4)"
        ></path>
      </g>
      <g>
        <circle cx="81.8" cy="101" r="28" fill="#171719"></circle>
        <path
          fill="none"
          stroke="url(#Gradiente_sem_nome_16)"
          strokeWidth="4.448"
          d="M94.1 77.3c5.6 6.7 17.6 25.4 20.8 46.2"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="none"
          stroke="url(#Gradiente_sem_nome_17)"
          strokeWidth="4.448"
          d="M78.1 98.2c10.2.6 33.1-1.4 43.3-14.6"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="none"
          stroke="url(#Gradiente_sem_nome_18)"
          strokeWidth="4.448"
          d="M86.5 119.7c4.1-8.4 18.2-23.3 42.3-16.3"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="#4347fe"
          d="M157.1 94.1h1.4a4.35 4.35 0 003.4-1.2 5.26 5.26 0 000-6.5 4.66 4.66 0 00-3.4-1.1 6.15 6.15 0 00-1.4.1zm8.3-4.3a8.68 8.68 0 01-.5 2.8 4.83 4.83 0 01-1.4 2 6.78 6.78 0 01-2.2 1.2 9.25 9.25 0 01-2.9.4 10.28 10.28 0 01-1.7-.1 5.66 5.66 0 01-1.8-.3V83.7l1.8-.3c.6 0 1.2-.1 1.7-.1a9.67 9.67 0 012.9.4 4.77 4.77 0 012.2 1.2 4.83 4.83 0 011.4 2 5.76 5.76 0 01.5 2.9zm9.6-6.4a7.35 7.35 0 014.1 1 3.79 3.79 0 01.7 5.2 3 3 0 01-1.7 1.2l.8 1a14.63 14.63 0 01.9 1.3c.3.5.6.9.9 1.4s.5 1 .7 1.4h-2.5c-.2-.4-.5-.9-.7-1.3a9.13 9.13 0 00-.8-1.3c-.3-.4-.5-.8-.8-1.2s-.5-.7-.7-1h-1.8V96h-2.3V83.7a11 11 0 011.8-.2 5.72 5.72 0 011.4-.1zm.1 2a5.28 5.28 0 00-1.3.1v4h1a6.15 6.15 0 001.4-.1 4.51 4.51 0 001.1-.3 1.17 1.17 0 00.6-.6 2.6 2.6 0 000-2 1.17 1.17 0 00-.6-.6 1.69 1.69 0 00-1-.3 2.54 2.54 0 00-1.2-.2zm11.5-1.8h2.3V96h-2.3zm12.7 12.6a13.4 13.4 0 01-2-.1 5.66 5.66 0 01-1.8-.3V83.7l.8-.1c.3 0 .6-.1.9-.1h1.8a14.92 14.92 0 012.1.2 5.78 5.78 0 011.7.6 2.66 2.66 0 011.1 1 2.93 2.93 0 01.4 1.6 2.6 2.6 0 01-.4 1.5 2.94 2.94 0 01-1.2 1 3.37 3.37 0 011.7 1.1 2.51 2.51 0 01.5 1.9 3.42 3.42 0 01-1.4 2.9 8.6 8.6 0 01-4.2.9zm-1.6-5.8v3.8a2.2 2.2 0 01.8.1h.8a5.7 5.7 0 001.3-.1c.3-.1.7-.2 1-.3a1.34 1.34 0 00.7-.6 1.69 1.69 0 00.3-1 1.41 1.41 0 00-.8-1.5 5.22 5.22 0 00-2.1-.4zm0-1.8h1.6a4.48 4.48 0 002-.4 1.28 1.28 0 00.7-1.3 1.44 1.44 0 00-.8-1.3 4.48 4.48 0 00-2-.4h-.9a1.48 1.48 0 00-.7.1zm17 7.6a13.4 13.4 0 01-2-.1 5.66 5.66 0 01-1.8-.3V83.7l.8-.1c.3 0 .6-.1.9-.1h1.8a14.92 14.92 0 012.1.2 5.78 5.78 0 011.7.6 2.66 2.66 0 011.1 1 2.93 2.93 0 01.4 1.6 2.6 2.6 0 01-.4 1.5 2.94 2.94 0 01-1.2 1 3.86 3.86 0 011.7 1.1 2.51 2.51 0 01.5 1.9 3.42 3.42 0 01-1.4 2.9 8.36 8.36 0 01-4.2.9zm-1.5-5.8v3.8a2.2 2.2 0 01.8.1h.8a5.7 5.7 0 001.3-.1c.3-.1.7-.2 1-.3a1.34 1.34 0 00.7-.6 1.69 1.69 0 00.3-1 1.41 1.41 0 00-.8-1.5 5.22 5.22 0 00-2.1-.4zm0-1.8h1.6a4.48 4.48 0 002-.4 1.28 1.28 0 00.7-1.3 1.44 1.44 0 00-.8-1.3 4.48 4.48 0 00-2-.4h-.9a1.48 1.48 0 00-.7.1zm17 7.6a13.4 13.4 0 01-2-.1 5.66 5.66 0 01-1.8-.3V83.7l.8-.1c.3 0 .6-.1.9-.1h1.8a14.92 14.92 0 012.1.2 5.78 5.78 0 011.7.6 2.66 2.66 0 011.1 1 2.93 2.93 0 01.4 1.6 2.6 2.6 0 01-.4 1.5 2.94 2.94 0 01-1.2 1 3.37 3.37 0 011.7 1.1 2.51 2.51 0 01.5 1.9 3.42 3.42 0 01-1.4 2.9 7.62 7.62 0 01-4.2.9zm-1.5-5.8v3.8a2.2 2.2 0 01.8.1h.8a5.7 5.7 0 001.3-.1c.3-.1.7-.2 1-.3a1.34 1.34 0 00.7-.6 1.69 1.69 0 00.3-1 1.41 1.41 0 00-.8-1.5 5.22 5.22 0 00-2.1-.4zm0-1.8h1.6a4.48 4.48 0 002-.4 1.28 1.28 0 00.7-1.3 1.44 1.44 0 00-.8-1.3 4.48 4.48 0 00-2-.4h-.9a1.48 1.48 0 00-.7.1zm21.1 5.4v2h-8V83.6h2.3V94zm5.3 2V83.6h8v1.9h-5.7v3.1h5.1v1.9h-5.1v3.7h6.2V96z"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="#fff"
          d="M153.1 120.5h-1.2l4.8-12.4h1.2zm9.8-6.1a6.63 6.63 0 01-2.8-1.4 2.52 2.52 0 01-.9-2 2.79 2.79 0 011.1-2.2 4.28 4.28 0 012.8-.9 4.65 4.65 0 012.1.5 3 3 0 011.4 1.3 3.37 3.37 0 01.5 1.7h-1.5a1.86 1.86 0 00-.7-1.6 2.71 2.71 0 00-1.9-.6 2.86 2.86 0 00-1.7.5 1.68 1.68 0 00-.6 1.4 1.43 1.43 0 00.6 1.2 7.66 7.66 0 002 .9 12.29 12.29 0 012.2.9 4.26 4.26 0 011.2 1.1 2.41 2.41 0 01.4 1.5 2.66 2.66 0 01-1.1 2.2 4.35 4.35 0 01-2.9.8 5.38 5.38 0 01-2.2-.4 4 4 0 01-1.6-1.2 2.73 2.73 0 01-.5-1.8h1.5a1.94 1.94 0 00.8 1.6 3.17 3.17 0 002 .6 3 3 0 001.8-.5 1.71 1.71 0 000-2.6c-.2-.4-.9-.7-2-1zm14.9-.2a6.53 6.53 0 01-.6 2.9 4.31 4.31 0 01-1.6 1.9 4.81 4.81 0 01-2.4.7 4 4 0 01-2.4-.7 4.31 4.31 0 01-1.6-1.9 6.39 6.39 0 01-.6-2.8v-.8a6.53 6.53 0 01.6-2.9 4.31 4.31 0 011.6-1.9 4.81 4.81 0 012.4-.7 4 4 0 012.4.7 4.31 4.31 0 011.6 1.9 6.53 6.53 0 01.6 2.9zm-1.5-.8a5.45 5.45 0 00-.8-3.1 2.71 2.71 0 00-2.3-1.1 2.66 2.66 0 00-2.2 1.1 5.1 5.1 0 00-.8 3v.8a5.69 5.69 0 00.8 3.1 3 3 0 004.6 0 5.1 5.1 0 00.8-3v-.8zm5.3 4.9h5.4v1.2h-6.9v-11.4h1.5zm11.3-3.4h-2.7v4.6h-1.5v-11.4h3.8a4.48 4.48 0 013 .9 3 3 0 011 2.5 3.29 3.29 0 01-.6 1.9 4 4 0 01-1.6 1.2l2.7 4.8v.1h-1.6zm-2.7-1.2h2.3a2.79 2.79 0 001.8-.6 2.17 2.17 0 00.1-3.1 2.44 2.44 0 00-1.8-.6h-2.3v4.3zm14.6 2.8H200l-1.1 3h-1.5l4.3-11.4h1.3l4.4 11.4h-1.5zm-4.3-1.2h3.9l-1.9-5.3zm16.8.6a4.34 4.34 0 01-1.3 2.8 4 4 0 01-3 1 4.16 4.16 0 01-3.2-1.4 6.05 6.05 0 01-1.2-3.9v-1.1a6.09 6.09 0 01.6-2.8 4 4 0 011.6-1.8 4.75 4.75 0 012.4-.6 4 4 0 012.9 1 4.34 4.34 0 011.3 2.8h-1.5a2.89 2.89 0 00-.9-2 2.44 2.44 0 00-1.8-.6 2.84 2.84 0 00-2.3 1.1 5.1 5.1 0 00-.8 3v1.1a5 5 0 00.8 2.9 2.53 2.53 0 002.2 1.1 2.71 2.71 0 001.9-.6 3.73 3.73 0 00.9-2zm10.8 3.6h-1.5v-5.3h-5.7v5.3h-1.5v-11.4h1.5v4.9h5.7v-4.9h1.5zm4.2 0h-1.5v-11.4h1.5zm6.6-7l2.7-4.4h1.8l-3.6 5.6 3.7 5.7h-1.8l-2.8-4.4-2.8 4.4h-1.8l3.7-5.7-3.6-5.6h1.8z"
          transform="translate(-22.4)"
        ></path>
      </g>
      <g className="social-network-link-legacy">
        <path
          fill="#171719"
          fillRule="evenodd"
          d="M697.2 151h18.5c4.6 0 10 2.9 10 8.9 0 4.7-1.3 6-4.3 8 4 1.8 5.2 3.7 5.6 8.5 0 5.9-4.3 10.8-11.9 10.8h-17.8V151zm56.3 24.1h-18.8c.3 4.1 2.4 6.4 6.3 6.4 2.1 0 4-.4 5.2-2.9h7.1c-.5 3.4-4.5 8.4-12.7 8.4-5.5 0-12.8-3.3-12.8-13.6 0-8.9 5.2-14 13-14 6.5 0 12.9 4.3 12.7 13.2zm-39.8-17.8h-8.3v8h8.3c3 0 4.8-1.3 4.8-4.1s-2-3.9-4.8-3.9zm0 14.1h-8.3v9.6h8.3c3.6 0 5.5-1.9 5.5-4.8.1-3.2-1.9-4.8-5.5-4.8zm21.2-.7c.2-3 2.1-5.6 5.7-5.6a5.43 5.43 0 015.8 5.2v.3h-11.5z"
          data-name="Subtract 3"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="url(#Gradiente_sem_nome_19)"
          d="M712.1 151H727.1V155.3H712.1z"
        ></path>
        <path
          fill="#4347fe"
          d="M678.7 226.2a13.4 13.4 0 01-2-.1 5.66 5.66 0 01-1.8-.3v-12.1l.8-.1a2.77 2.77 0 01.9-.1h1.8a14.92 14.92 0 012.1.2 5.78 5.78 0 011.7.6 2.66 2.66 0 011.1 1 2.93 2.93 0 01.4 1.6 2.6 2.6 0 01-.4 1.5 2.94 2.94 0 01-1.2 1 3.86 3.86 0 011.7 1.1 2.51 2.51 0 01.5 1.9 3.42 3.42 0 01-1.4 2.9 8.36 8.36 0 01-4.2.9zm-1.5-5.8v3.8a2.2 2.2 0 01.8.1h.8a5.7 5.7 0 001.3-.1c.3-.1.7-.2 1-.3s.5-.4.7-.6a1.69 1.69 0 00.3-1 1.41 1.41 0 00-.8-1.5 5.22 5.22 0 00-2.1-.4zm0-1.8h1.6a4.48 4.48 0 002-.4 1.21 1.21 0 00.7-1.3 1.44 1.44 0 00-.8-1.3 4.48 4.48 0 00-2-.4h-.8a1.48 1.48 0 00-.7.1zm13.2 7.4v-12.5h8v1.9h-5.8v3.1h5.1v1.9h-5.1v3.7h6.2v1.9zm21.8-12.4h2.3V226h-2.3v-5.5h-5.4v5.5h-2.3v-12.5h2.3v5h5.4zm17.1 12.4c-.2-.5-.3-1-.5-1.5a8.8 8.8 0 01-.5-1.5H723c-.2.5-.3 1-.5 1.5l-.5 1.5h-2.3c.5-1.3.9-2.6 1.3-3.7s.8-2.2 1.2-3.2.8-2 1.2-2.9l1.2-2.7h2.1l1.2 2.7c.4.9.8 1.9 1.2 2.9s.8 2.1 1.2 3.2.9 2.4 1.3 3.7zm-3.6-10c-.3.6-.6 1.4-1 2.3s-.7 1.9-1.1 3h4.1c-.4-1.1-.8-2.1-1.1-3s-.7-1.7-.9-2.3zm19.7 10c-.4-.7-.9-1.4-1.4-2.2s-1-1.6-1.6-2.4-1.1-1.6-1.7-2.3-1.1-1.4-1.6-2v8.9h-2.2v-12.5h1.9a14.28 14.28 0 011.5 1.8c.5.7 1.1 1.4 1.7 2.1a18.82 18.82 0 011.6 2.3c.5.8 1 1.4 1.4 2.1v-8.3h2.3V226zm14 .3a6.9 6.9 0 01-2.5-.4 5 5 0 01-1.9-1.3 7.19 7.19 0 01-1.2-2.1 8.63 8.63 0 01-.4-2.8 6.92 6.92 0 01.5-2.8 6.25 6.25 0 011.3-2 5.33 5.33 0 012-1.3 6.72 6.72 0 012.4-.4 6.6 6.6 0 011.4.1 4.51 4.51 0 011.1.3c.3.1.5.2.8.3l.4.2-.7 1.9a6.12 6.12 0 00-1.2-.5 5.08 5.08 0 00-1.7-.3 4 4 0 00-1.5.3 3.6 3.6 0 00-1.2.8 3.92 3.92 0 00-.8 1.4 6.45 6.45 0 00-.3 2 11 11 0 00.2 1.8 3.69 3.69 0 00.7 1.4 2.73 2.73 0 001.2.9 4.67 4.67 0 001.7.3 13.55 13.55 0 002-.2 6.12 6.12 0 001.2-.5l.6 1.9-.6.3a4.65 4.65 0 01-.9.3 5.16 5.16 0 01-1.1.2 3.89 3.89 0 01-1.5.2zm9.6-.3v-12.5h8v1.9h-5.7v3.1h5.1v1.9h-5.1v3.7h6.2v1.9z"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="#fff"
          d="M670.1 250h-1.2l4.8-12.4h1.2zm9.9-6a6.63 6.63 0 01-2.8-1.4 2.52 2.52 0 01-.9-2 2.79 2.79 0 011.1-2.2 4.28 4.28 0 012.8-.9 4.65 4.65 0 012.1.5 3 3 0 011.4 1.3 3.37 3.37 0 01.5 1.7h-1.5a1.86 1.86 0 00-.7-1.6 2.71 2.71 0 00-1.9-.6 2.86 2.86 0 00-1.7.5 1.68 1.68 0 00-.6 1.4 1.43 1.43 0 00.6 1.2 7.66 7.66 0 002 .9 12.29 12.29 0 012.2.9 4.26 4.26 0 011.2 1.1 2.41 2.41 0 01.4 1.5 2.66 2.66 0 01-1.1 2.2 4.35 4.35 0 01-2.9.8 5.38 5.38 0 01-2.2-.4 4 4 0 01-1.6-1.2 2.73 2.73 0 01-.5-1.8h1.5a1.94 1.94 0 00.8 1.6 3.17 3.17 0 002 .6 3 3 0 001.8-.5 1.61 1.61 0 00.6-1.3 1.49 1.49 0 00-.6-1.3c-.2-.4-1-.7-2-1zm14.9-.3a6.53 6.53 0 01-.6 2.9 4.31 4.31 0 01-1.6 1.9 4.81 4.81 0 01-2.4.7 4 4 0 01-2.4-.7 4.31 4.31 0 01-1.6-1.9 6.39 6.39 0 01-.6-2.8v-.8a6.53 6.53 0 01.6-2.9 4.31 4.31 0 011.6-1.9 4.81 4.81 0 012.4-.7 4 4 0 012.4.7 4.31 4.31 0 011.6 1.9 6.53 6.53 0 01.6 2.9zm-1.5-.7a5.45 5.45 0 00-.8-3.1 2.71 2.71 0 00-2.3-1.1 2.66 2.66 0 00-2.2 1.1 5.1 5.1 0 00-.8 3v.8a5.69 5.69 0 00.8 3.1 3 3 0 004.6 0 5.1 5.1 0 00.8-3v-.8zm5.3 4.8h5.4v1.2h-6.9v-11.4h1.5zm11.3-3.3h-2.7v4.6h-1.5v-11.4h3.8a4.48 4.48 0 013 .9 3 3 0 011 2.5 3.29 3.29 0 01-.6 1.9 4 4 0 01-1.6 1.2l2.7 4.8v.1h-1.6zm-2.7-1.3h2.3a2.79 2.79 0 001.8-.6 2.17 2.17 0 00.1-3.1 2.44 2.44 0 00-1.8-.6h-2.3v4.3zm14.6 2.9h-4.8l-1.1 3h-1.5l4.3-11.4h1.3l4.4 11.4H723zm-4.3-1.2h3.9l-1.9-5.3zm16.8.5a4.34 4.34 0 01-1.3 2.8 4 4 0 01-3 1 4.16 4.16 0 01-3.2-1.4 6.05 6.05 0 01-1.2-3.9v-1.1a6.09 6.09 0 01.6-2.8 4 4 0 011.6-1.8 4.75 4.75 0 012.4-.6 4 4 0 012.9 1 4.34 4.34 0 011.3 2.8H733a2.89 2.89 0 00-.9-2 2.44 2.44 0 00-1.8-.6 2.84 2.84 0 00-2.3 1.1 5.1 5.1 0 00-.8 3v1.1a5 5 0 00.8 2.9 2.53 2.53 0 002.2 1.1 2.71 2.71 0 001.9-.6 3.73 3.73 0 00.9-2zm10.7 3.7h-1.5v-5.3h-5.7v5.3h-1.5v-11.4h1.5v4.9h5.7v-4.9h1.5zm4.3 0h-1.5v-11.4h1.5zm6.6-7.1l2.7-4.4h1.8l-3.6 5.6 3.7 5.7h-1.8l-2.8-4.4-2.8 4.4h-1.8l3.7-5.7-3.6-5.6h1.8z"
          transform="translate(-22.4)"
        ></path>
      </g>
      <g
        className={`social-network-item ${
          activeLink === 'github' ? 'is-active' : ''
        }`}
      >
        <circle cx="720.8" cy="396" r="28" fill="#171719"></circle>
        <path
          fill="url(#Gradiente_sem_nome_20)"
          d="M726.3 395.8c0 7.6 3.4 12.3 12.6 13.2-1 .9-1.4 1.8-1.8 3.7a6.08 6.08 0 01-7.6-1.8c-.9-1.9-1.8-2.7-4.6-3.4-.8-.1-1.2-.1-1.4.3s.1.6.4.9c.9.8 2.3 1.1 3.4 3.5 1.6 3.6 3.2 4.7 7 4.7a13.33 13.33 0 002.8-.3v6.7a31.07 31.07 0 0013.9-.2v-9.2a5.83 5.83 0 00-1.8-4.7c9.7-1.1 12.4-6 12.5-13.2.1-3.9-.8-5.4-2.8-7.8a8.62 8.62 0 00-.4-7.2c-2.7 0-4.6.6-7.5 2.8a19.6 19.6 0 00-6.8-.9 16.51 16.51 0 00-7 .9 11.89 11.89 0 00-7.6-2.8 10 10 0 00-.3 7.2c-2.4 2.3-3 4-3 7.6z"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="#4347fe"
          d="M707.9 450.2a3.85 3.85 0 00-3 1.2 5 5 0 00-1 3.3 13.66 13.66 0 00.2 1.9 3.69 3.69 0 00.7 1.4 2.73 2.73 0 001.2.9 4.67 4.67 0 001.7.3h1c.2 0 .5-.1.7-.1v-4.5h2.3v6a7.49 7.49 0 01-1.6.4 22.75 22.75 0 01-2.6.2 7.27 7.27 0 01-2.5-.4 5 5 0 01-1.9-1.3 8.17 8.17 0 01-1.2-2 8.63 8.63 0 01-.4-2.8 6.92 6.92 0 01.5-2.8 6.25 6.25 0 011.3-2 5.33 5.33 0 012-1.3 6.72 6.72 0 012.4-.4 7.57 7.57 0 011.5.1 5.27 5.27 0 011.2.3c.3.1.5.2.8.3l.5.2-.7 1.9a6.94 6.94 0 00-1.3-.5c-.7-.1-1.2-.2-1.8-.3zm10-1.7h2.3V461h-2.3zm17.5 0v2h-3.8V461h-2.3v-10.6h-3.8v-2zm13 0h2.3V461h-2.3v-5.5H743v5.5h-2.3v-12.5h2.3v5h5.4zm13.7 12.8a5.7 5.7 0 01-2.2-.4 3.69 3.69 0 01-2.4-2.6 6.45 6.45 0 01-.3-2v-7.8h2.3v7.6a7.72 7.72 0 00.2 1.5 3.13 3.13 0 00.5 1 2.18 2.18 0 00.8.5 3.59 3.59 0 001.1.2 4.25 4.25 0 001.1-.2 2.18 2.18 0 00.8-.5 1.91 1.91 0 00.5-1 7.72 7.72 0 00.2-1.5v-7.6h2.3v7.8a6.45 6.45 0 01-.3 2 5.07 5.07 0 01-.9 1.6 4.92 4.92 0 01-1.5 1 5.38 5.38 0 01-2.2.4zm15.2-.1a13.4 13.4 0 01-2-.1 5.66 5.66 0 01-1.8-.3v-12.1l.8-.1c.3 0 .6-.1.9-.1h1.8a14.92 14.92 0 012.1.2 4.92 4.92 0 011.7.6 2.66 2.66 0 011.1 1 2.93 2.93 0 01.4 1.6 2.6 2.6 0 01-.4 1.5 2.94 2.94 0 01-1.2 1 3.86 3.86 0 011.7 1.1 2.51 2.51 0 01.5 1.9 3.42 3.42 0 01-1.4 2.9 9.58 9.58 0 01-4.2.9zm-1.5-5.8v3.8a2.2 2.2 0 01.8.1h.8a5.7 5.7 0 001.3-.1 2.93 2.93 0 001-.3c.3-.1.5-.4.7-.6a1.69 1.69 0 00.3-1 1.41 1.41 0 00-.8-1.5 5.38 5.38 0 00-2.2-.4zm0-1.8h1.6a4.48 4.48 0 002-.4 1.28 1.28 0 00.7-1.3 1.44 1.44 0 00-.8-1.3 4.48 4.48 0 00-2-.4h-.9a1.48 1.48 0 00-.7.1z"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="#fff"
          d="M696.1 483h-1.2l4.8-12.4h1.2zm9.9-6a6.63 6.63 0 01-2.8-1.4 2.52 2.52 0 01-.9-2 2.79 2.79 0 011.1-2.2 4.28 4.28 0 012.8-.9 4.65 4.65 0 012.1.5 3 3 0 011.4 1.3 3.37 3.37 0 01.5 1.7h-1.5a1.86 1.86 0 00-.7-1.6 2.71 2.71 0 00-1.9-.6 2.86 2.86 0 00-1.7.5 1.68 1.68 0 00-.6 1.4 1.43 1.43 0 00.6 1.2 7.66 7.66 0 002 .9 12.29 12.29 0 012.2.9 4.26 4.26 0 011.2 1.1 2.41 2.41 0 01.4 1.5 2.66 2.66 0 01-1.1 2.2 4.35 4.35 0 01-2.9.8 5.38 5.38 0 01-2.2-.4 4 4 0 01-1.6-1.2 2.73 2.73 0 01-.5-1.8h1.5a1.94 1.94 0 00.8 1.6 3.17 3.17 0 002 .6 3 3 0 001.8-.5 1.71 1.71 0 000-2.6c-.2-.4-1-.7-2-1zm14.9-.3a6.53 6.53 0 01-.6 2.9 4.31 4.31 0 01-1.6 1.9 4.81 4.81 0 01-2.4.7 4 4 0 01-2.4-.7 4.31 4.31 0 01-1.6-1.9 6.39 6.39 0 01-.6-2.8v-.8a6.53 6.53 0 01.6-2.9 4.31 4.31 0 011.6-1.9 4.81 4.81 0 012.4-.7 4 4 0 012.4.7 4.31 4.31 0 011.6 1.9 6.53 6.53 0 01.6 2.9zm-1.5-.7a5.45 5.45 0 00-.8-3.1 2.71 2.71 0 00-2.3-1.1 2.66 2.66 0 00-2.2 1.1 5.1 5.1 0 00-.8 3v.8a5.69 5.69 0 00.8 3.1 3 3 0 004.6 0 5.1 5.1 0 00.8-3v-.8zm5.3 4.8h5.4v1.2h-6.9v-11.4h1.5zm11.3-3.3h-2.7v4.6h-1.5v-11.4h3.8a4.48 4.48 0 013 .9 3 3 0 011 2.5 3.29 3.29 0 01-.6 1.9 4 4 0 01-1.6 1.2l2.7 4.8v.1h-1.6zm-2.7-1.3h2.3a2.79 2.79 0 001.8-.6 2.17 2.17 0 00.1-3.1 2.44 2.44 0 00-1.8-.6h-2.3v4.3zm14.6 2.9h-4.8l-1.1 3h-1.5l4.3-11.4h1.3l4.4 11.4H749zm-4.3-1.2h3.9l-1.9-5.3zm16.8.5a4.34 4.34 0 01-1.3 2.8 4 4 0 01-3 1 4.16 4.16 0 01-3.2-1.4 6.05 6.05 0 01-1.2-3.9v-1.1a6.09 6.09 0 01.6-2.8 4 4 0 011.6-1.8 4.75 4.75 0 012.4-.6 4 4 0 012.9 1 4.34 4.34 0 011.3 2.8H759a2.89 2.89 0 00-.9-2 2.44 2.44 0 00-1.8-.6 2.84 2.84 0 00-2.3 1.1 5.1 5.1 0 00-.8 3v1.1a5 5 0 00.8 2.9 2.53 2.53 0 002.2 1.1 2.71 2.71 0 001.9-.6 3.73 3.73 0 00.9-2zm10.7 3.7h-1.5v-5.3h-5.7v5.3h-1.5v-11.4h1.5v4.9h5.7v-4.9h1.5zm4.3 0h-1.5v-11.4h1.5zm6.6-7.1l2.7-4.4h1.8l-3.6 5.6 3.7 5.7h-1.8l-2.8-4.4-2.8 4.4h-1.8l3.7-5.7-3.6-5.6h1.8z"
          transform="translate(-22.4)"
        ></path>
      </g>
      <g className="social-network-link-legacy">
        <path
          fill="#171719"
          stroke="url(#Gradiente_sem_nome_21)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.2"
          d="M768.2 636l28 18.2v19.6l-28 18.2-28-18.2v-19.6z"
          data-name="Vector 2"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="none"
          stroke="url(#Gradiente_sem_nome_22)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.2"
          d="M768.2 692v-18.2"
          data-name="Vector 3"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="none"
          stroke="url(#Gradiente_sem_nome_23)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.2"
          d="M796.2 654.2l-28 19.6-28-19.6"
          data-name="Vector 4"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="none"
          stroke="url(#Gradiente_sem_nome_24)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.2"
          d="M740.2 673.8l28-19.6 28 19.6"
          data-name="Vector 5"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="none"
          stroke="url(#Gradiente_sem_nome_25)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.2"
          d="M768.2 636v18.2"
          data-name="Vector 6"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="#4347fe"
          d="M722.5 727.3a6.9 6.9 0 01-2.5-.4 5 5 0 01-1.9-1.3 8.17 8.17 0 01-1.2-2 8.63 8.63 0 01-.4-2.8 6.92 6.92 0 01.5-2.8 8.58 8.58 0 011.3-2 5 5 0 011.9-1.3 6.72 6.72 0 012.4-.4 6.6 6.6 0 011.4.1 4.51 4.51 0 011.1.3c.3.1.5.2.8.3l.4.2-.7 1.8a5 5 0 00-1.3-.5 5.08 5.08 0 00-1.7-.3 4 4 0 00-1.5.3 3.6 3.6 0 00-1.2.8 3.92 3.92 0 00-.8 1.4 6.45 6.45 0 00-.3 2 11 11 0 00.2 1.8 3.69 3.69 0 00.7 1.4 2.73 2.73 0 001.2.9 4.67 4.67 0 001.7.3 13.55 13.55 0 002-.2 6.12 6.12 0 001.2-.5l.6 1.9-.6.3-.9.3a4.25 4.25 0 01-1.1.2 3 3 0 01-1.3.2zm11.1-6.5a6.28 6.28 0 00.3 1.9 6.11 6.11 0 00.7 1.4 2.73 2.73 0 001.2.9 4.15 4.15 0 003.1 0 4.7 4.7 0 001.2-.9 3.69 3.69 0 00.7-1.4 5.82 5.82 0 00.3-1.9 6.28 6.28 0 00-.3-1.9 3.69 3.69 0 00-.7-1.4 2.73 2.73 0 00-1.2-.9 4.15 4.15 0 00-3.1 0 2.73 2.73 0 00-1.2.9 3.69 3.69 0 00-.7 1.4 3.08 3.08 0 00-.3 1.9zm9.7 0a8.68 8.68 0 01-.5 2.8 4.64 4.64 0 01-1.3 2 4.74 4.74 0 01-1.9 1.2 5.87 5.87 0 01-2.3.4 6.72 6.72 0 01-2.4-.4 6.15 6.15 0 01-1.9-1.2 5.71 5.71 0 01-1.3-2.1 9.18 9.18 0 01-.5-2.8 6.63 6.63 0 01.5-2.8 6.25 6.25 0 011.3-2 8 8 0 011.9-1.3 7.55 7.55 0 014.7 0 5 5 0 011.9 1.3 6.25 6.25 0 011.3 2 7.1 7.1 0 01.5 2.9zm8.3 4.3h1.4a4.47 4.47 0 003.7-7.4 4.26 4.26 0 00-3.7-1.4 6.15 6.15 0 00-1.4.1zm8.4-4.3a8.68 8.68 0 01-.5 2.8 4.83 4.83 0 01-1.4 2 5.32 5.32 0 01-2.2 1.2 9.25 9.25 0 01-2.9.4 10.28 10.28 0 01-1.7-.1 5.66 5.66 0 01-1.8-.3v-12.1l1.8-.3c.7 0 1.2-.1 1.7-.1a9.67 9.67 0 012.9.4 4.77 4.77 0 012.2 1.2 4.83 4.83 0 011.4 2 9.29 9.29 0 01.5 2.9zm6 6.2v-12.4h8v1.9h-5.7v3.1h5.1v1.9h-5.1v3.7h6.2v1.9zm17.7-12.6a7.69 7.69 0 014.2 1 3.5 3.5 0 011.5 3.1 4.06 4.06 0 01-.4 1.9 3.48 3.48 0 01-1.1 1.3 6.7 6.7 0 01-1.8.7 9.74 9.74 0 01-2.4.2h-1.1v4.4h-2.3v-12.3a11 11 0 011.8-.2 8.6 8.6 0 011.6-.1zm.2 2a6.6 6.6 0 00-1.4.1v4.3h1.1a5.34 5.34 0 002.5-.5 1.83 1.83 0 00.9-1.8 3.55 3.55 0 00-.2-1 1.34 1.34 0 00-.7-.6 1.69 1.69 0 00-1-.3 2.54 2.54 0 00-1.2-.2zM795 727v-12.5h8v1.9h-5.8v3.1h5.1v1.9h-5.1v3.7h6.2v1.9zm22.6 0c-.4-.7-.9-1.4-1.4-2.2s-1-1.6-1.6-2.4-1.1-1.6-1.7-2.3-1.1-1.4-1.6-2v8.9h-2.2v-12.5h1.9a14.28 14.28 0 011.5 1.8c.5.7 1.1 1.4 1.7 2.1a18.82 18.82 0 011.6 2.3c.5.8 1 1.4 1.4 2.1v-8.3h2.3V727z"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="#fff"
          d="M714.1 745h-1.2l4.8-12.4h1.2zm9.9-6a6.63 6.63 0 01-2.8-1.4 2.52 2.52 0 01-.9-2 2.79 2.79 0 011.1-2.2 4.28 4.28 0 012.8-.9 4.65 4.65 0 012.1.5 3 3 0 011.4 1.3 3.37 3.37 0 01.5 1.7h-1.5a1.86 1.86 0 00-.7-1.6 2.71 2.71 0 00-1.9-.6 2.86 2.86 0 00-1.7.5 1.68 1.68 0 00-.6 1.4 1.43 1.43 0 00.6 1.2 7.66 7.66 0 002 .9 12.29 12.29 0 012.2.9 4.26 4.26 0 011.2 1.1 2.41 2.41 0 01.4 1.5 2.66 2.66 0 01-1.1 2.2 4.35 4.35 0 01-2.9.8 5.38 5.38 0 01-2.2-.4 4 4 0 01-1.6-1.2 2.73 2.73 0 01-.5-1.8h1.5a1.94 1.94 0 00.8 1.6 3.17 3.17 0 002 .6 3 3 0 001.8-.5 1.61 1.61 0 00.6-1.3 1.49 1.49 0 00-.6-1.3c-.2-.4-1-.7-2-1zm14.9-.3a6.53 6.53 0 01-.6 2.9 4.31 4.31 0 01-1.6 1.9 4.81 4.81 0 01-2.4.7 4 4 0 01-2.4-.7 4.31 4.31 0 01-1.6-1.9 6.39 6.39 0 01-.6-2.8v-.8a6.53 6.53 0 01.6-2.9 4.31 4.31 0 011.6-1.9 4.81 4.81 0 012.4-.7 4 4 0 012.4.7 4.31 4.31 0 011.6 1.9 6.53 6.53 0 01.6 2.9zm-1.5-.7a5.45 5.45 0 00-.8-3.1 2.71 2.71 0 00-2.3-1.1 2.66 2.66 0 00-2.2 1.1 5.1 5.1 0 00-.8 3v.8a5.69 5.69 0 00.8 3.1 3 3 0 004.6 0 5.1 5.1 0 00.8-3v-.8zm5.3 4.8h5.4v1.2h-6.9v-11.4h1.5zm11.3-3.3h-2.7v4.6h-1.5v-11.4h3.8a4.48 4.48 0 013 .9 3 3 0 011 2.5 3.29 3.29 0 01-.6 1.9 4 4 0 01-1.6 1.2l2.7 4.8v.1h-1.6zm-2.7-1.3h2.3a2.79 2.79 0 001.8-.6 2.17 2.17 0 00.1-3.1 2.44 2.44 0 00-1.8-.6h-2.3v4.3zm14.6 2.9h-4.8l-1.1 3h-1.5l4.3-11.4h1.3l4.4 11.4H767zm-4.3-1.2h3.9l-1.9-5.3zm16.8.5a4.34 4.34 0 01-1.3 2.8 4 4 0 01-3 1 4.16 4.16 0 01-3.2-1.4 6.05 6.05 0 01-1.2-3.9v-1.1a6.09 6.09 0 01.6-2.8 4 4 0 011.6-1.8 4.75 4.75 0 012.4-.6 4 4 0 012.9 1 4.34 4.34 0 011.3 2.8H777a2.89 2.89 0 00-.9-2 2.44 2.44 0 00-1.8-.6 2.84 2.84 0 00-2.3 1.1 5.1 5.1 0 00-.8 3v1.1a5 5 0 00.8 2.9 2.53 2.53 0 002.2 1.1 2.71 2.71 0 001.9-.6 3.73 3.73 0 00.9-2zm10.7 3.7h-1.5v-5.3h-5.7v5.3h-1.5v-11.4h1.5v4.9h5.7v-4.9h1.5zm4.3 0h-1.5v-11.4h1.5zm6.6-7.1l2.7-4.4h1.8l-3.6 5.6 3.7 5.7h-1.8l-2.8-4.4-2.8 4.4h-1.8l3.7-5.7-3.6-5.6h1.8z"
          transform="translate(-22.4)"
        ></path>
      </g>
      <g>
        <path
          fill="#171719"
          d="M73.1 395h24.2a15.88 15.88 0 0115.9 15.9v24.2A15.88 15.88 0 0197.3 451H73.1a15.88 15.88 0 01-15.9-15.9v-24.2A15.88 15.88 0 0173.1 395z"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="url(#Gradiente_sem_nome_26)"
          d="M80.7 424.1h-7.2v7.7h7.2V451h8.5v-19.2h6.5l.9-7.7h-7.4V420c-.5-4.7 2.3-5.5 3.9-5.6H97v-6.7l-6-.5c-8.1-.1-10.3 6.3-10.4 9.6v7.3z"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="#4347fe"
          d="M27.7 485v-12.5h7.9v1.9H30v3.2h5v1.9h-5v5.4zm20.9 0c-.2-.5-.3-1-.5-1.5s-.3-1-.5-1.5h-5.3c-.2.5-.3 1-.5 1.5l-.5 1.4h-2.4c.5-1.3.9-2.6 1.3-3.7s.8-2.2 1.2-3.2.8-2 1.2-2.9l1.2-2.7H46l1.2 2.7c.4.9.8 1.9 1.2 2.9s.8 2.1 1.2 3.2.9 2.4 1.3 3.7h-2.3zm-3.7-10.1c-.3.6-.6 1.4-1 2.3s-.7 1.9-1.1 3H47c-.4-1.1-.8-2.1-1.1-3a17.43 17.43 0 00-1-2.3zm16.6 10.4a6.9 6.9 0 01-2.5-.4 5 5 0 01-1.9-1.3 8.17 8.17 0 01-1.2-2 8.63 8.63 0 01-.4-2.8 6.92 6.92 0 01.5-2.8 6.25 6.25 0 011.3-2 5 5 0 011.9-1.3 6.72 6.72 0 012.4-.4 6.6 6.6 0 011.4.1 4.51 4.51 0 011.1.3c.3.1.5.2.8.3l.4.2-.7 1.9a5 5 0 00-1.3-.5 5.08 5.08 0 00-1.7-.3 4 4 0 00-1.5.3 3.6 3.6 0 00-1.2.8 3.92 3.92 0 00-.8 1.4 6.45 6.45 0 00-.3 2 11 11 0 00.2 1.8 3.69 3.69 0 00.7 1.4 2.73 2.73 0 001.2.9 4.67 4.67 0 001.7.3 13.55 13.55 0 002-.2 6.12 6.12 0 001.2-.5l.6 1.9-.6.3-.9.3a4.25 4.25 0 01-1.1.2 5.7 5.7 0 01-1.3.1zm9.5-.3v-12.5h8v1.9h-5.7v3.1h5.1v1.9h-5.1v3.7h6.2v1.9zm17.9.1a13.4 13.4 0 01-2-.1 5.66 5.66 0 01-1.8-.3v-12.1l.8-.1c.3 0 .6-.1.9-.1h1.8a16.2 16.2 0 012.2.1 5.78 5.78 0 011.7.6 2.66 2.66 0 011.1 1 2.93 2.93 0 01.4 1.6 2.6 2.6 0 01-.4 1.5 2.94 2.94 0 01-1.2 1 3.37 3.37 0 011.7 1.1 2.51 2.51 0 01.5 1.9 3.42 3.42 0 01-1.4 2.9 6.43 6.43 0 01-4.3 1zm-1.5-5.7v3.8a2.2 2.2 0 01.8.1h.8a5.7 5.7 0 001.3-.1c.3-.1.7-.2 1-.3a1.34 1.34 0 00.7-.6 1.69 1.69 0 00.3-1 1.41 1.41 0 00-.8-1.5 5.22 5.22 0 00-2.1-.4zm0-1.8H89a4.48 4.48 0 002-.4 1.28 1.28 0 00.7-1.3 1.44 1.44 0 00-.8-1.3 4.48 4.48 0 00-2-.4H88a1.48 1.48 0 00-.7.1zm15 1.2a6.28 6.28 0 00.3 1.9 6.11 6.11 0 00.7 1.4 2.73 2.73 0 001.2.9 4.15 4.15 0 001.6.3 3.65 3.65 0 001.5-.3 4.7 4.7 0 001.2-.9 3.69 3.69 0 00.7-1.4 5.82 5.82 0 00.3-1.9 6.28 6.28 0 00-.3-1.9 3.69 3.69 0 00-.7-1.4 2.73 2.73 0 00-1.2-.9 4 4 0 00-1.5-.3 4.53 4.53 0 00-1.6.3 2.73 2.73 0 00-1.2.9 3.69 3.69 0 00-.7 1.4 5.82 5.82 0 00-.3 1.9zm9.7 0a6.63 6.63 0 01-.5 2.8 4.64 4.64 0 01-1.3 2 4.74 4.74 0 01-1.9 1.2 5.87 5.87 0 01-2.3.4 6.72 6.72 0 01-2.4-.4 6.15 6.15 0 01-1.9-1.2 6.25 6.25 0 01-1.3-2 9.18 9.18 0 01-.5-2.8 6.63 6.63 0 01.5-2.8 5.75 5.75 0 013.3-3.3 7.24 7.24 0 014.6 0 5 5 0 011.9 1.3 6.25 6.25 0 011.3 2 5.21 5.21 0 01.5 2.8zm7.9 0a6.28 6.28 0 00.3 1.9 6.11 6.11 0 00.7 1.4 2.73 2.73 0 001.2.9 4.15 4.15 0 001.6.3 3.65 3.65 0 001.5-.3 3.13 3.13 0 001.1-.9 3.69 3.69 0 00.7-1.4 5.82 5.82 0 00.3-1.9 6.28 6.28 0 00-.3-1.9 3.69 3.69 0 00-.7-1.4 3.13 3.13 0 00-1.1-.9 4 4 0 00-1.5-.3 4.53 4.53 0 00-1.6.3 2.73 2.73 0 00-1.2.9 3.69 3.69 0 00-.7 1.4 10.79 10.79 0 00-.3 1.9zm9.8 0a6.63 6.63 0 01-.5 2.8 4.64 4.64 0 01-1.3 2 4.74 4.74 0 01-1.9 1.2 5.87 5.87 0 01-2.3.4 6.72 6.72 0 01-2.4-.4 6.15 6.15 0 01-1.9-1.2 6.25 6.25 0 01-1.3-2 9.18 9.18 0 01-.5-2.8 6.63 6.63 0 01.5-2.8 6.25 6.25 0 011.3-2 8 8 0 011.9-1.3 7.24 7.24 0 014.6 0 5 5 0 011.9 1.3 6.25 6.25 0 011.3 2 6.71 6.71 0 01.6 2.8zm13.5 6.2a14.31 14.31 0 00-1.1-1.5 17.38 17.38 0 00-1.3-1.5 18.48 18.48 0 00-1.4-1.4 17.41 17.41 0 00-1.4-1.2v5.6h-2.3v-12.4h2.3v5.1l1.2-1.3 1.3-1.4 1.2-1.4 1-1.2h2.7a16.61 16.61 0 01-1.3 1.4c-.5.5-.9 1-1.4 1.5s-.9 1-1.4 1.5a18.48 18.48 0 01-1.4 1.4 19.2 19.2 0 011.5 1.4c.5.5 1 1 1.5 1.6a22 22 0 011.4 1.8 21.41 21.41 0 011.3 1.9z"
          transform="translate(-22.4)"
        ></path>
        <path
          fill="#fff"
          d="M23.6 509.5h-1.2l4.7-12.4h1.2zm9.9-6.1a6.63 6.63 0 01-2.8-1.4 2.52 2.52 0 01-.9-2 2.79 2.79 0 011.1-2.2 4.28 4.28 0 012.8-.9 4.65 4.65 0 012.1.5 3 3 0 011.4 1.3 3.37 3.37 0 01.5 1.7h-1.5a1.86 1.86 0 00-.7-1.6 2.71 2.71 0 00-1.9-.6 2.86 2.86 0 00-1.7.5 1.68 1.68 0 00-.6 1.4 1.43 1.43 0 00.6 1.2 7.66 7.66 0 002 .9 12.29 12.29 0 012.2.9 4.26 4.26 0 011.2 1.1 2.41 2.41 0 01.4 1.5 2.66 2.66 0 01-1.1 2.2 4.35 4.35 0 01-2.9.8 5.38 5.38 0 01-2.2-.4 4 4 0 01-1.6-1.2 2.73 2.73 0 01-.5-1.8h1.5a1.94 1.94 0 00.8 1.6 3.17 3.17 0 002 .6 3 3 0 001.8-.5 1.71 1.71 0 000-2.6 4.06 4.06 0 00-2-1zm14.9-.2a6.53 6.53 0 01-.6 2.9 4.31 4.31 0 01-1.6 1.9 4.81 4.81 0 01-2.4.7 4 4 0 01-2.4-.7 4.31 4.31 0 01-1.6-1.9 6.39 6.39 0 01-.6-2.8v-.8a6.53 6.53 0 01.6-2.9 4.31 4.31 0 011.6-1.9 4.81 4.81 0 012.4-.7 4 4 0 012.4.7 4.31 4.31 0 011.6 1.9 6.53 6.53 0 01.6 2.9zm-1.5-.8a5.45 5.45 0 00-.8-3.1 2.71 2.71 0 00-2.3-1.1 2.66 2.66 0 00-2.2 1.1 5.1 5.1 0 00-.8 3v.8a5.69 5.69 0 00.8 3.1 3 3 0 004.6 0 5.1 5.1 0 00.8-3v-.8zm5.2 4.9h5.4v1.2h-6.9v-11.4h1.5zm11.3-3.4h-2.7v4.6h-1.5v-11.4H63a4.48 4.48 0 013 .9 3 3 0 011 2.5 3.29 3.29 0 01-.6 1.9 4 4 0 01-1.6 1.2l2.7 4.8v.1h-1.6zm-2.7-1.2H63a2.79 2.79 0 001.8-.6 2.17 2.17 0 00.1-3.1 2.44 2.44 0 00-1.8-.6h-2.3v4.3zm14.7 2.8h-4.8l-1.1 3H68l4.3-11.4h1.3l4.4 11.4h-1.5zm-4.3-1.2H75l-2-5.3zm16.7.6a4.34 4.34 0 01-1.3 2.8 4 4 0 01-3 1 4.16 4.16 0 01-3.2-1.4 6.05 6.05 0 01-1.2-3.9v-1.1a6.09 6.09 0 01.6-2.8 4 4 0 011.6-1.8 4.75 4.75 0 012.4-.6 4 4 0 012.9 1 4.34 4.34 0 011.3 2.8h-1.5a2.89 2.89 0 00-.9-2 2.44 2.44 0 00-1.8-.6 2.84 2.84 0 00-2.3 1.1 5.1 5.1 0 00-.8 3v1.1a5 5 0 00.8 2.9 2.53 2.53 0 002.2 1.1 2.71 2.71 0 001.9-.6 3.73 3.73 0 00.9-2zm10.8 3.6h-1.5v-5.3h-5.7v5.3h-1.5v-11.4h1.5v4.9h5.7v-4.9h1.5zm4.3 0h-1.5v-11.4h1.5zm6.6-7l2.7-4.4h1.8l-3.6 5.6 3.7 5.7h-1.8l-2.8-4.4-2.8 4.4h-1.8l3.7-5.7-3.6-5.6h1.8z"
          transform="translate(-22.4)"
        ></path>
      </g>
      <circle
        cx="103.3"
        cy="158.5"
        r="6"
        fill="#121214"
        stroke="#4347fe"
        strokeWidth="3"
        data-name="figny8-isle 6"
      ></circle>
      <circle
        cx="119.3"
        cy="624.5"
        r="6"
        fill="#121214"
        stroke="#4347fe"
        strokeWidth="3"
        data-name="figny8-isle 7"
      ></circle>
      <a
        href="https://www.instagram.com/solrachix"
        target="_blank"
        rel="noopener noreferrer"
        className="social-network-link"
        aria-label="Instagram"
        onMouseEnter={() => setActiveLink('instagram')}
        onMouseLeave={() => setActiveLink(null)}
        onFocus={() => setActiveLink('instagram')}
        onBlur={() => setActiveLink(null)}
      >
        <title>Instagram</title>
        <rect
          className="social-network-link-hit"
          x="365"
          y="0"
          width="64"
          height="60"
          rx="16"
          pointerEvents="all"
        ></rect>
      </a>
      <a
        href="https://www.youtube.com/@solrachix"
        target="_blank"
        rel="noopener noreferrer"
        className="social-network-link"
        aria-label="YouTube"
        onMouseEnter={() => setActiveLink('youtube')}
        onMouseLeave={() => setActiveLink(null)}
        onFocus={() => setActiveLink('youtube')}
        onBlur={() => setActiveLink(null)}
      >
        <title>YouTube</title>
        <rect
          className="social-network-link-hit"
          x="32"
          y="596"
          width="64"
          height="56"
          rx="16"
          pointerEvents="all"
        ></rect>
      </a>
      <a
        href="https://github.com/solrachix"
        target="_blank"
        rel="noopener noreferrer"
        className="social-network-link"
        aria-label="GitHub"
        onMouseEnter={() => setActiveLink('github')}
        onMouseLeave={() => setActiveLink(null)}
        onFocus={() => setActiveLink('github')}
        onBlur={() => setActiveLink(null)}
      >
        <title>GitHub</title>
        <rect
          className="social-network-link-hit"
          x="690"
          y="366"
          width="64"
          height="64"
          rx="16"
          pointerEvents="all"
        ></rect>
      </a>
      <a
        href="https://www.linkedin.com/in/solrachix/"
        target="_blank"
        rel="noopener noreferrer"
        className="social-network-link social-network-link-badge"
        aria-label="LinkedIn"
        onMouseEnter={() => setActiveLink('linkedin')}
        onMouseLeave={() => setActiveLink(null)}
        onFocus={() => setActiveLink('linkedin')}
        onBlur={() => setActiveLink(null)}
      >
        <title>LinkedIn</title>
        <rect
          className="social-network-link-hit"
          x="595"
          y="148"
          width="64"
          height="64"
          rx="16"
          pointerEvents="all"
        ></rect>
        <g
          className={`social-network-link-content ${
            activeLink === 'linkedin' ? 'is-active' : ''
          }`}
          pointerEvents="none"
        >
          <g className="social-network-link-icon">
            <circle cx="627" cy="180" r="27"></circle>
            <text x="612" y="190">
              in
            </text>
          </g>
          <text className="social-network-link-label" x="678" y="226">
            LINKEDIN
          </text>
          <text className="social-network-link-handle" x="678" y="248">
            /SOLRACHIX
          </text>
        </g>
      </a>
      <a
        href="mailto:eu@carlos-miguel.dev"
        className="social-network-link social-network-link-badge"
        aria-label="E-mail"
        onMouseEnter={() => setActiveLink('email')}
        onMouseLeave={() => setActiveLink(null)}
        onFocus={() => setActiveLink('email')}
        onBlur={() => setActiveLink(null)}
      >
        <title>E-mail</title>
        <rect
          className="social-network-link-hit"
          x="698"
          y="620"
          width="58"
          height="48"
          rx="12"
          pointerEvents="all"
        ></rect>
        <g
          className={`social-network-link-content ${
            activeLink === 'email' ? 'is-active' : ''
          }`}
          pointerEvents="none"
        >
          <g className="social-network-link-icon">
            <rect x="704" y="626" width="46" height="33" rx="5"></rect>
            <path d="m706 631 21 17 21-17"></path>
          </g>
          <text className="social-network-link-label" x="698" y="688">
            E-MAIL
          </text>
          <text className="social-network-link-handle" x="698" y="710">
            CONTATO
          </text>
        </g>
      </a>
    </svg>
  )
}

export default SocialNetwork
